export default __webpack_public_path__ + "static/figma-grid-bf0c30e3142022de45a9831a949000c5.gif";